/* eslint-disable import/prefer-default-export,import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import { MAIN_ICON_COLORS } from 'assets/components';

export const PendingCardInfoPopup = ({ label }) => (
  <div
    style={{ top: '0.2rem', left: '58%', width: '14.375rem' }}
    className="position-absolute shadow p-3 bg-disabled rounded border-1 text-center popup-info custom-popup-info">
    <i
      className="position-absolute shadow"
      style={{ top: '50%', left: '-7px', marginTop: '-1rem' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none">
        <path d="M0 7.88574L8 14.8857L8 0.885742L0 7.88574Z" fill={MAIN_ICON_COLORS.INFO_ARROW} />
      </svg>
    </i>
    <p className="text-white text-f6 text-start">{label}</p>
  </div>
);

PendingCardInfoPopup.propTypes = {
  label: PropTypes.string.isRequired,
};
